/** TODO: Remove this file once backend status unification is complete.
 * Temporary: Handling of company status is currently based on the `status` as returned by the API.
 * This file may change once backend status unification is complete (e.g., for deactivated/deleted statuses, etc.).
 */
export const isRowDeactivated = (row) => {
  const s = (row.status || "").toLowerCase();
  return s === "deactivated" || s === "inactive";
};

/** @returns {'pending' | 'rejected' | 'deactivated' | 'active'} */
export const getCompanyStatusKey = (row) => {
  const s = (row.status || "").toLowerCase();
  if (s === "rejected") return "rejected";
  if (s === "pending") return "pending";
  if (s === "deactivated" || s === "inactive") return "deactivated";
  if (s === "approved") return "active";
  return "active";
};
